import Login from '@containers/auth/auth-login';
import SetNewPassword from '@containers/auth/auth-set-new-password';
import ResetPasswordConfirm from '@containers/auth/auth-reset-password-confirm';
import ErrorPage from './error-page-404';
import SignUp from '@containers/auth/auth-sign-up';
import Confirmation from '@containers/auth/auth-confirmation';

const publicRoutes = [
  {
    path: '/',
    element: <Login />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/login',
    element: <Login />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/set-new-password',
    element: <SetNewPassword />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/reset-confirm',
    element: <ResetPasswordConfirm />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/sign-up',
    element: <SignUp />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/free-trial',
    element: <SignUp title="Free Trial Sign Up" />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/confirmation',
    element: <Confirmation />,
    errorElement: <ErrorPage />,
  },
];

export default publicRoutes;
